module.exports = __webpack_public_path__ + "static/img/1.b44de2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/1.jpg
// module id = aK7q
// module chunks = 0